import { array, number, oneOfType, string } from 'prop-types'
import SplideJs from '@ui/component/SplideJs'
import CallPhotoCard from './CallPhotoCard'

const CallPhotosSlider = ({ callId, photos, address = null }) => {
  if (!photos.length) {
    return <></>
  }

  const photosSlides = photos.map(photo => {
    return <CallPhotoCard photo={photo} address={address} imageProps={{ 'data-splide-lazy': photo.scanPhoto }} key={`call-${callId}-${photo.id}`} />
  })

  return <SplideJs slides={photosSlides} />
}

CallPhotosSlider.propTypes = {
  callId: oneOfType([number, string]),
  photos: array,
  address: string
}

export default CallPhotosSlider
